import React, { useEffect, useState } from 'react';
import { TFunction, withTranslation } from "react-i18next";
import "./UnloggedHelpComponent.scss";
import { ToastContainer } from 'react-toastify';
import { ReactComponent as LogoSVG } from "itd-common/assets/images/brand/logo.svg";
import Footer from '../layout/Footer';
import { WebCache } from '../../services/WebCache';
import HelpAccordion from './HelpAccordion';

interface IProps {
    t: TFunction
}

interface ISectionFilterConfig {
    title: string;
    key: string;
    ids: string[];
}

interface IFilteredSection {
    title: string;
    values: Record<string, any>[];
}

const SECTIONS: ISectionFilterConfig[]= [{
        title: "Acceso",
        key: "session",
        ids: ['1','11','12']
    },
    {
        title: "Google Authenticator",
        key: "session",
        ids: ['2','3','4','5','6','8','9','10']
    },
    {
        title: "Perdí mi celular",
        key: "lostYourPhone",
        ids: ['1','2','3']
    }
]

const UnloggedHelpComponent: React.FC<IProps> = ({ t }: IProps) => { 
    const pages = t("pages", { returnObjects: true }) as Record<string, any>;
    const [pagesFiltered, setPagesFiltered] = useState<IFilteredSection[]>([]);
    const currentUser: number = WebCache.getCurrentUser()?.countryId ?? 2;
    const [section, setSection] = useState<string>("session");
    const [activeKey, setActiveKey] = React.useState("help");
    const isAllQuestionsOpen = true;
    const isSearching = false;
    const [bgImage, setBgImage] = useState("/bgmerchantcenter.jpg");
    
    useEffect(() => {
        const updateBg = () => {
            setBgImage(window.innerWidth <= 425 ? "/bgmerchantcentermobile.jpg" : "/bgmerchantcenter.jpg");
        };
        updateBg();
        window.addEventListener("resize", updateBg);
        return () => window.removeEventListener("resize", updateBg);
    }, []);
        
    useEffect(() => {
        let values= buildPagesToShow();
        setPagesFiltered(values);
    }, []);

    const buildPagesToShow = (): any[] => {
        let filteredQuestionsBySection: any[] = [];

        SECTIONS.forEach(({ title, key, ids }) => {
            const sectionItems = pages[key] ?? [];
            const matchedItems = sectionItems.filter((item: any) => {
                const itemId = item.id.split('-')[1]; // extrae el número del id, ej: "session-1" → "1"
                return ids.includes(itemId);
            });
            filteredQuestionsBySection.push({
                title: title,
                values: matchedItems
            });
        });
        return filteredQuestionsBySection;
    };

    useEffect(()=> {
            console.log(pages[section])
            console.log(currentUser)
        },[]);

    return (
        <React.Fragment>
            <ToastContainer autoClose={3000} ></ToastContainer>
            <div className="login help" >
                <div className="page">
                    <div className="container-login100" style={{ backgroundImage: `url(${bgImage})`}}>
                        <div className="wrap-login100 p-7">
                            <div className='brand-logo-container mb-6'>
                                <LogoSVG className='brand-logo-container__image'></LogoSVG> <div className='divider'></div> <h4>Merchant center</h4>
                            </div>
                            <div className="backward">
                                <div className="backward__init">
                                    <a onClick={() => window.history.back()} className="backToLogin">
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <g id="ico/arrow-left">
                                                <path id="Vector 1" d="M10 4L2 12L10 20" stroke="#333333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                                <line id="Line 7" x1="3" y1="12" x2="21" y2="12" stroke="#333333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                            </g>
                                        </svg>            
                                        <span className='backward__init__callback'>{t(`Volver`)}</span>
                                    </a>
                                </div>
                            </div> 
                            <h2 className="fw-bold text-start mb-3 mt-2">
                                {t(`unloggedTitle`)}
                            </h2>
                            <p className=''>{t(`unloggedSubtitle`)}</p>
                            <>
                            {pagesFiltered.map((sectionData, index) => {
                                const { title, values } = sectionData;
                                return (
                                    <div key={`section-${index}`} className="my-5">
                                        <h3 className="my-5 fw-bold">{title}</h3>
                                        <HelpAccordion
                                            activeKey={activeKey}
                                            setActiveKey={setActiveKey}
                                            items={values}
                                            isAllQuestionsOpen={isAllQuestionsOpen}
                                            isSearching={isSearching}
                                            currentUser={currentUser}
                                        />
                                    </div>
                                );
                            })}
                            </>
                        </div>
                    </div>
                </div>
                <Footer isValid={false}/>
            </div>
        </React.Fragment>
    )
}
export default withTranslation("translation-help")(UnloggedHelpComponent);